<template>
  <div class="release-shop main-bg">
    <div class="main-wrap">
      <div class="mt20">
        <business-menu></business-menu>
        <div class="fr release-r">
          <span class="icon-notice">i</span><nav-crumb class="crumb-pt"></nav-crumb>
          <el-form :hide-required-asterisk="true" :model="businessForm" :rules="businessRules" ref="businessForm" label-width="110px" class="business-form">
            <div class="base-info part">
              <p class="title-name">基础信息</p>
              <div class="part-top">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="店铺名称" prop="shopName">
                      <el-input class="inp-txt" v-model="businessForm.shopName" placeholder="请输入店铺名称"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="选择地址" prop="currentCity">
                      <el-cascader
                              ref="shopAddress"
                              class="inp-txt"
                              placeholder="请选择地址"
                              v-model="businessForm.currentCity"
                              :options="cityOptions"
                              @change="handleCityAreaChange">
                      </el-cascader>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="详细地址" prop="address">
                      <el-input class="inp-txt" v-model="businessForm.address" placeholder="请输入详细地址"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="16">
                    <el-form-item label="">
                      <map-content id="address_map" class="store-map" :address="businessForm.address" :cityName="businessForm.cityName" :longitude="businessForm.longitude" :latitude="businessForm.latitude"></map-content>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="商家信息" prop="desc">
                      <el-input
                              type="textarea"
                              placeholder="请填写商家简介"
                              v-model="businessForm.desc"
                              :autosize="{ minRows: 5, maxRows: 10}"
                              resize="none"
                              maxlength="20"
                              show-word-limit
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="上传图片">
                  <upload-file flag="添加店铺logo" v-model="businessForm.headImg" :limit="1" />
                  <upload-file flag="添加店铺背景图" v-model="businessForm.backImg" :limit="1" />
                </el-form-item>
                <el-form-item>
                  <button type="button" class="btn-apply" @click="commitShopEdit('businessForm')">确认更改</button>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
    import BusinessMenu from '../../components/setting/businessMenu'
    import navCrumb from '../../components/crumb/index'
    import Rules from '../../utils/rules'
    import CityArea from '../../assets/js/city.json'
    import uploadFile from '../../components/uploadFile/index'
    import mapContent from '../../components/map.vue'
    import {shopEdit,getShopInfoForMe} from '../../api/shop'
  export default {
      data(){
          return {
              shopInfo:JSON.parse(localStorage.getItem('shop'))||null,
              dialogImageUrl: '',//显示上传图片
              dialogVisible: false,//隐藏
              cityOptions:[],//城市选择
              businessForm:{
                  shopName:'',//门店名称
                  peopleName:'',//负责人姓名
                  idCardNo:'',//身份证号
                  storeCity:'',//店铺城市
                  detailBusinessAddress:'',//详细地址
                  currentCity:[],//选中城市
              },
              businessRules:{
                  shopName: Rules.required('请输入店铺名称'),
                  currentCity: Rules.required('请选择省市区'),
                  address: Rules.required('输入详细地址'),
                  desc:Rules.required('输入商家信息')
              }
          }
      },
      components:{
          BusinessMenu,
          navCrumb,
          mapContent,
          uploadFile
      },
      created () {
      },
      mounted(){
          if(this.shopInfo){
              let form = this.shopInfo;
              this.businessForm=form;
              this.businessForm.currentCity=[form.provinceId,form.cityId,form.areaId]
          }
          this.cityOptions=CityArea.provinces;
      },
      methods:{
          handleCityAreaChange(value){
              console.log(value)
          },
          handleRemove(file, fileList) {
              console.log(file, fileList);
          },
          handlePictureCardPreview(file) {
              this.dialogImageUrl = file.url;
              this.dialogVisible = true;
          },
          commitShopEdit(formName){
              this.$refs[formName].validate((valid) => {
                  if (valid) {
                      let arrText;
                      arrText = this.$refs.shopAddress.inputValue.split('/');
                      for(let i=0;i<arrText.length;i++){
                          if(i===0){
                              this.businessForm.provinceName=arrText[i].trim();
                              this.businessForm.provinceId=this.businessForm.currentCity[i];
                          }
                          if(i===1){
                              this.businessForm.cityName=arrText[i].trim();
                              this.businessForm.cityId=this.businessForm.currentCity[i];
                          }
                          if(i===2){
                              this.businessForm.areaName=arrText[i].trim();
                              this.businessForm.areaId=this.businessForm.currentCity[i];
                          }
                      }
                      shopEdit(this.businessForm).then(res=>{
                          this.$message({
                              message:res.msg,
                              type:'success'
                          });
                          this.getShopInfo()
                      })
                  } else {
                      console.log('error submit!!');
                      return false;
                  }
              });
          },
          getShopInfo(){
              getShopInfoForMe({
                  shopId:this.shopInfo.shopId
              }).then(res=>{
                  this.businessForm=res.data.shop;
                  this.businessForm.currentCity=[this.businessForm.provinceId,this.businessForm.cityId,this.businessForm.areaId]
                  localStorage.setItem('shop',JSON.stringify(this.businessForm));
              })
          },
      }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/css/common';
  .crumb-pt{padding:0 0 20px;display: inline-block;line-height:20px;}
  .release-r{
    width:1000px;
    .icon-notice{
      vertical-align: top;
      margin-right:10px;
      display: inline-block;
      text-align: center;
      line-height:20px;
      color:#fff;
      width:20px;
      height:20px;
      background-color:$main-color;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
    }
    .goods-radio{
      width:300px;
      height:40px;
      padding-left:40px;
      line-height:40px;
    }
  }
  .part{
    background-color:#fff;

    .title-name{font-size:14px;color:#222;
      height:54px;
      line-height:54px;
      padding-left:30px;
      font-weight:600;border-bottom:1px dashed #EEEEEE;}
  }
  .part-top{
    padding:20px 80px;
  }
.business-form{
  .inp-txt{width:300px;height:38px;background-color:#FCFCFC;
    display: inline-block;}
}
  .store-map{
    width:626px;
    height:288px;
    background-color:$main-color;
  }
  .upload-certificates{
    display: inline-block;
    &+.upload-certificates{margin-left:50px;}
    border:1px dashed #E4E5E5;
    width:200px;
    height:150px;
    text-align: center;
    color:#999999;
    .upload-plus{padding-top:30px;}
    .btn-plus{font-size:60px;color:#c9c9c9;}

  }
  .btn-apply{
    width:170px;
    height:36px;
    background:$main-color;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    font-size:14px;
    color:#fff;
    margin-top:26px;
  }
</style>
<style lang="scss">
  @import '../../assets/css/common';
  .business-form{
    .el-form-item{
      white-space:nowrap;}
    .el-input__inner{background-color:#FCFCFC;border:1px solid #E4E5E5;}
  }
  .el-radio{margin-right:40px;}
  .el-radio__inner:hover{border:1px solid $main-color;}
  .el-radio__input.is-checked .el-radio__inner{
    border-color: $main-color;
    background: $main-color;}
  .el-radio__input.is-checked+.el-radio__label{color:#333333;}
  .el-textarea__inner{border:1px solid #E4E5E5;background-color:#FCFCFC;
    -webkit-border-radius: 0px;
    -moz-border-radius: 0px;
    border-radius: 0px;}
</style>
